module.exports = __webpack_public_path__ + "img/left1.bf2b0168.jpg";